import { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { Container, IconRemove } from './style'

import { Input, Select as CustomSelect, Select } from 'components/Form'
import { useToast } from 'hooks/toast'

import api from 'services/api'
import { useMenuFoodContext } from '../../../../contexts'
import { apiListDishTypes } from '../../../../domain/api'
import { SearchComponentProduct } from './SearchComponentProduct'

type IFormAddNewItemProps = {
  typeForm: 'create' | 'update'
  weekDay: string
  weekDayLabel: string
  week: number
}

export const FormAddNewItem = ({
  typeForm,
  weekDay,
  weekDayLabel,
  week
}: IFormAddNewItemProps): JSX.Element => {
  const {
    templateComposition,
    setTemplateComposition,
    checkError,
    onChangeOfActualErrors,
    hasItemsSelect
  } = useMenuFoodContext()

  const { addToast } = useToast()

  const [dishTypeList, setDishTypeList] = useState<IDishType[]>([])
  useEffect(() => {
    if (dishTypeList.length === 0) {
      api
        .get(apiListDishTypes())
        .then(res => {
          const orderedData: IDishType[] = res.data.sort(
            (a: IDishType, b: IDishType) => a.name.localeCompare(b.name)
          )
          setDishTypeList(orderedData)
        })
        .catch(() => {
          addToast({
            type: 'error',
            title: 'Erro ao carregar as instituições',
            description:
              'Houve um erro ao carregar as instituições disponíveis no banco de dados.'
          })
        })
    }
  }, [addToast, dishTypeList])

  const activeDishTypeList = dishTypeList.filter(dishType => dishType.is_active)

  return (
    <Container className="table-responsive">
      <div>
        <div className="table-content-relative">
          <div
            style={{
              marginBottom: '15px',
              width: 'fit-content',
              padding: '10px 15px',
              display: 'flex',
              gap: '10px',
              fontSize: '16px',
              fontWeight: 'bold',
              background: '#f5f8fa'
            }}
          >
            <p>Semana {week}: </p>
            <p>{weekDayLabel}-feira</p>
          </div>

          <table className="table table-bordered mb-0">
            <tr>
              <th className="fw-bold fs-6">Tipo</th>
              <th className="fw-bold fs-6 ps-3">Item</th>
              {hasItemsSelect === 'true' && (
                <th className="fw-bold fs-6 ps-3">Padrão</th>
              )}
              <th className="fw-bold fs-6">Qntd.</th>
              <th className="fw-bold fs-6">Porção</th>
              <th className="fw-bold fs-6 text-center">Ações</th>
            </tr>
            <tbody>
              {templateComposition?.map((item, index: number) => {
                return (
                  <tr key={index}>
                    <td className="col-md-3">
                      <CustomSelect
                        name={`composition.${index}.dish_type`}
                        options={
                          typeForm === 'create'
                            ? activeDishTypeList.map(dishType => ({
                                name: dishType.name,
                                value: dishType.id
                              }))
                            : dishTypeList.map(dishType => ({
                                name: dishType.name,
                                value: dishType.id
                              }))
                        }
                        rules={{ required: true }}
                        onChange={event => {
                          setTemplateComposition(prev => {
                            const copy = [...prev]
                            copy[index].dish_type_id = Number(
                              event.target.value
                            )
                            const dishTypeName = dishTypeList.find(
                              dishType => dishType.id === +event.target.value
                            ).name
                            copy[index].dish_type_name = dishTypeName
                            copy[index].dish_name = undefined
                            copy[index].dish_id = undefined
                            return copy
                          })
                          onChangeOfActualErrors(item.id, 'error_type')
                        }}
                        value={templateComposition[index].dish_type_id}
                        blank
                        nestedError={checkError(item.id, 'error_type')}
                        controlled
                        defaultValue={''}
                      />
                    </td>

                    <td>
                      {SearchComponentProduct({
                        index,
                        templateComposition,
                        setTemplateComposition,
                        dishTypeList,
                        typeForm,
                        checkError,
                        onChangeOfActualErrors
                      })}
                    </td>
                    {hasItemsSelect === 'true' && (
                      <td style={{ width: '150px' }}>
                        <Select
                          name={`composition.${index}.is_default_dish`}
                          options={[
                            {
                              name: 'Sim',
                              value: 'true'
                            },
                            {
                              name: 'Não',
                              value: 'false'
                            }
                          ]}
                          blank
                          onChange={event => {
                            setTemplateComposition(prev => {
                              const copy = [...prev]
                              copy[index].is_default_dish =
                                event.target.value === 'true'
                              return copy
                            })
                            onChangeOfActualErrors(item.id, 'error_is_default')
                          }}
                          // rules={{ position: 'left' }}
                          controlled
                          nestedError={checkError(item.id, 'error_is_default')}
                          value={
                            templateComposition[index].is_default_dish ===
                            undefined
                              ? undefined
                              : templateComposition[index].is_default_dish
                              ? 'true'
                              : 'false'
                          }
                        />
                      </td>
                    )}

                    <td style={{ width: '100px' }}>
                      <Input
                        name={`composition.${index}.dish_amount`}
                        type="number"
                        min={0}
                        onChange={event => {
                          setTemplateComposition(prev => {
                            const copy = [...prev]
                            copy[index].dish_amount = Number(event.target.value)
                            return copy
                          })
                          onChangeOfActualErrors(item.id, 'error_amount')
                        }}
                        rules={{ position: 'left', required: true }}
                        controlled
                        nestedError={checkError(item.id, 'error_amount')}
                        value={templateComposition[index].dish_amount}
                      />
                    </td>

                    <td style={{ width: '200px' }}>
                      <Input
                        name={`composition.${index}.portion`}
                        onChange={event => {
                          setTemplateComposition(prev => {
                            const copy = [...prev]
                            copy[index].portion = event.target.value
                            return copy
                          })
                        }}
                        rules={{ position: 'left' }}
                        controlled
                        value={templateComposition[index].portion}
                      />
                    </td>

                    <td className="actions" style={{ width: '70px' }}>
                      <div className="d-flex  justify-content-center align-items-center pt-4 pe-4">
                        <IconRemove
                          onClick={() =>
                            setTemplateComposition(prev => {
                              const copy = [...prev]
                              copy.splice(index, 1)
                              return copy
                            })
                          }
                        />
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
      <button
        type="button"
        className="btn btn-dark btn-sm mb-5"
        onClick={() =>
          setTemplateComposition(prev => {
            const copy = [...prev]
            const final = [
              ...copy,
              {
                id: uuidv4(),
                dish_id: undefined,
                dish_type_id: undefined,
                dish_amount: 1,
                dish_name: undefined,
                is_default_dish: false,
                dish_type_name: undefined,
                portion: undefined,
                week_day: weekDay,
                week: week
              }
            ]
            return final
          })
        }
      >
        + Item
      </button>
      {templateComposition.length < 4 && (
        <div style={{ height: '200px' }}></div>
      )}
    </Container>
  )
}
